import React, {useEffect, useState} from 'react'
import {Rect} from "react-konva";
import useImage from "use-image";
import GridLayer from "../design-editor/konva-editor/grid-layer";

const BackgroundVariantImage = ({
                                    imageDetail,
                                    settings,
                                }) => {
    const [image] = useImage(imageDetail.src, 'anonymous');
    const shapeRef = React.useRef();

    return (
        <>
            {image &&

                <>
                    <Rect
                        name={'variant-image'}
                        ref={shapeRef}
                        x={imageDetail.x}
                        y={imageDetail.y}
                        width={settings?.width}
                        height={settings?.height}
                        fillPatternImage={image}
                        fillPatternRepeat={imageDetail?.fillPatternRepeat}
                        fillPatternRotation={imageDetail?.fillPatternRotation}
                        fillPatternOffsetX={imageDetail?.fillPatternOffsetX}
                        fillPatternOffsetY={imageDetail?.fillPatternOffsetY}
                        fillPatternScaleX={imageDetail?.fillPatternScaleX}
                        fillPatternScaleY={imageDetail?.fillPatternScaleY}
                        listening={false}/>
                </>

            }
        </>
    )
}

export default BackgroundVariantImage
